import React, { Component } from 'react';
import './questions-list.scss';
import { Constants, ImageConstants } from '../../../../constants/constants';
import { getImageSource } from '../../../../utility/image-source'
import CwContentViewer from '../../../common/cw-content-viewer/cw-content-viewer'
import CanvasPreview from '../../../common/canvas/canvas'
import GeometryTranspiler from '../../../common/geometry/geometry-parser'
import ReactTooltip from 'react-tooltip';
import DropdownV4 from '../../../common/dropdown-v4/dropdown';
import SessionCache from '../../../routes/session-cache';


class QuestionList extends Component {

    state = {
        isCompetecyQuestionsPresent: false,

    }

    contentsHash = this.props.contentsHash || {}

    selectedSkillHash = {}

    constructor(props) {
        super(props)

        // console.log(this.props.approximateTime, this.props.contents, this.props.showCompetencyOnly)
        this.user = SessionCache.getUser()

        this.state = {
            contents: this.props.contents,
            reload: true,
            questionCount: this.props.questionCount,
            approximateTime: this.props.approximateTime,
            enableSelectionButton: false,
            showCompetencyOnly: this.props.showCompetencyOnly,
            selectedFilter: [],
            selectAll: this.props.selectAll || true
        }

        if (Object.keys(this.props.contentsHash).length) {
            this.contentsHash = this.props.contentsHash
            this.props.contents.forEach(skill => {
                if (skill.questions.length) {
                    skill.questions.forEach(item => {
                        if (!this.contentsHash[item._id]) {
                            this.contentsHash[item._id] = { contentId: item._id, eloId: item.eloId, selected: true }
                            // if (this.mapContentIdsToEloId[item.eloId]) {
                            //     this.mapContentIdsToEloId[item.eloId].push(item._id)
                            // } else {
                            //     this.mapContentIdsToEloId[item.eloId] = [item._id]
                            // }
                        }
                    })
                }
            });
        } else {
            this.props.contents.forEach(skill => {
                if (skill.questions.length) {
                    skill.questions.forEach(item => {
                        this.contentsHash[item._id] = { contentId: item._id, eloId: item.eloId, selected: true }
                        // if (this.mapContentIdsToEloId[item.eloId]) {
                        //     this.mapContentIdsToEloId[item.eloId].push(item._id)
                        // } else {
                        //     this.mapContentIdsToEloId[item.eloId] = [item._id]
                        // }
                    })
                }
            });
        }


        this.filterHash = {}
        for (let i = 0; i < this.props.eloDropdownItems.length; i++) {
            let obj = this.props.eloDropdownItems[i]

            let key = obj['skill']
            if (this.filterHash[key]) {
                this.filterHash[key].push(obj)
            } else {
                this.filterHash[key] = [obj]
            }
        }
        this.state.options = this.props.eloDropdownItems ? JSON.parse(JSON.stringify(this.props.eloDropdownItems)) : []

        if (this.state.selectedFilter?.length) {
            let options = []
            this.state.selectedFilter.forEach(element => {
                this.filterHash[element] && options.push(...this.filterHash[element])
            })
            this.state.options = options
        }

        // console.log(this.filterHash)

    }

    componentDidMount() {

        let isCompetecyQuestionsPresent = this.state.isCompetecyQuestionsPresent

        if (this.props.contents.length) {
            for (let i = 0; i < this.props.contents.length; i++) {
                let skill = this.props.contents[i]
                for (let j = 0; j < skill.questions.length; j++) {

                    let question = skill.questions[j]

                    if ((question.questionCategory === 'C1' ||
                        question.content.competency && question.content.competency.id === 'YES' ||
                        question.skill === 'Comprehension')) {
                        isCompetecyQuestionsPresent = true
                        break;
                    }
                }
            }
        }

        this.setState({ isCompetecyQuestionsPresent })
    }

    setSelectedQuestions = (value, selectAll, selectedElo = []) => {

        // if (this.props.questionCount != this.state.questionCount) {
        console.log(value, selectedElo)
        let obj = {
            selectedContentAssessment: true,
            contentsHash: this.contentsHash,
            approximateTime: this.state.approximateTime,
            questionCount: this.state.questionCount,
            selectAll,
            selectedElo
        }
        this.props.delegate && this.props.delegate.setSelectedQuestions && this.props.delegate.setSelectedQuestions(obj, value)
        // }

        if (this.state.showCompetencyOnly) {
            this.props.delegate && this.props.delegate.setSelectedQuestions && this.props.delegate.setSelectedQuestions()
        }
    }


    onSelectQuestion = (contentId, value, key) => {
        // console.log(this.props.questionCount)

        if (this.contentsHash[contentId]) {

            this.contentsHash[contentId].selected = value

            let contentValues = Object.values(this.contentsHash)

            let mins = 0

            if (value) {
                if (key === 'Knowledge') {
                    mins = 1  // 1 min for one Question
                } else if (key === 'Calculation') {
                    mins = 2 // 1.5 min for Each question
                } else if (key === 'Modelling') {
                    mins = 3 // 2.5 min for Each Question
                } else if (key === 'Comprehension') {
                    mins = 4 // 3.5 min for Each Question
                } else if (key === 'Conceptual Understanding') {
                    mins = 1 // // 1 min for Each Question
                }
                else if (key === 'Analytical Reasoning & Interpretation') {
                    mins = 2 // 2 min for Each Question
                }
                else if (key === 'Visualization & Representation') {
                    mins = 2.5 // 2.5 min for Each Question
                }
                else if (key === 'Mathematical Application') {
                    mins = 3 // 3 min for Each Question
                } else if (key === 'Application to Practical Skills') {
                    mins = 1.5 // 1.5 min for Each Question
                }


                this.setState({ questionCount: this.state.questionCount + 1, approximateTime: this.state.approximateTime + mins }, () => {
                    if (this.props.questionCount === this.state.questionCount) {
                        this.setState({ enableSelectionButton: false })
                    }
                })



                let selectedElo = [
                    ...new Set(contentValues.filter(d => d.selected).map(d => d.eloId))
                ];

                // console.log(selectedElo)

                this.setState({ reload: false, selectedElo }, () => {
                    this.setState({ reload: true })

                    this.setSelectedQuestions(false, false, selectedElo)
                })



                this.props.delegate && this.props.delegate.reloadToSetSelectedElo && this.props.delegate.reloadToSetSelectedElo()


            } else {
                if (key === 'Knowledge') {
                    mins = 1  // 1 min for one Question
                } else if (key === 'Calculation') {
                    mins = 2 // 1.5 min for Each question
                } else if (key === 'Modelling') {
                    mins = 3 // 2.5 min for Each Question
                } else if (key === 'Comprehension') {
                    mins = 4 // 3.5 min for Each Question
                } else if (key === 'Conceptual Understanding') {
                    mins = 1 // // 1 min for Each Question
                }
                else if (key === 'Analytical Reasoning & Interpretation') {
                    mins = 2 // 2 min for Each Question
                }
                else if (key === 'Visualization & Representation') {
                    mins = 2.5 // 2.5 min for Each Question
                }
                else if (key === 'Mathematical Application') {
                    mins = 3 // 3 min for Each Question
                } else if (key === 'Application to Practical Skills') {
                    mins = 1.5 // 1.5 min for Each Question
                }
                this.setState({ questionCount: this.state.questionCount - 1, approximateTime: this.state.approximateTime - mins }, () => {
                    if (this.props.questionCount != this.state.questionCount - 1) {
                        this.setState({ enableSelectionButton: true })
                    }
                })

                const validEloIds = [
                    ...new Set(
                        contentValues
                            .filter(d => d.selected === true)
                            .map(d => d.eloId)
                    )
                ];

                let selectedElo = contentValues.filter(d =>
                    validEloIds.includes(d.eloId)
                );

                selectedElo = selectedElo.map(item => item.eloId)

                // console.log(selectedElo)

                this.setState({ reload: false }, () => {
                    this.setState({ reload: true })

                    this.setSelectedQuestions(false, false, selectedElo)
                })

                this.props.delegate && this.props.delegate.reloadToSetSelectedElo && this.props.delegate.reloadToSetSelectedElo()

            }
        }
    }






    onClickBack = () => {
        // this.props.back()

    }

    renderList = () => {

        let continousIndex = 1

        return (
            this.state.contents?.map((skill, index) => (
                <div className="concept-wrapper" onMouseEnter={ReactTooltip.rebuild}>
                    <div className="concept-title">{skill?.skill}</div>
                    <div >
                        {
                            skill.questions.map((question, qnIndex) => (
                                <div className='row pt-4 flex-no-wrap ' style={{ marginLeft: "-0.3rem" }} >
                                    {
                                        !this.props.questionSelection ?
                                            <div className='col-2 ml-0 elo-index pr-0 d-flex width-of-question-number'
                                            >
                                                <div className='ml-2'>{`Q${continousIndex++}`}</div>
                                            </div>
                                            :
                                            <div className='col-2 ml-0 elo-index pr-0 d-flex width-of-question-number cursor-pointer'
                                                onClick={() => this.onSelectQuestion(question._id, !this.contentsHash[question._id].selected, question.skill)}>
                                                <div>
                                                    {
                                                        this.state.reload && this.contentsHash[question._id] && this.contentsHash[question._id].selected ? <div className="">
                                                            <img className="green-tick-icon" src={getImageSource(ImageConstants.WHITE_CHECK_BOX)} />
                                                        </div>
                                                            :
                                                            <div className="check-box"></div>
                                                    }
                                                </div>
                                                <div className='ml-4'>{`Q${continousIndex++}`}</div>
                                            </div>
                                    }

                                    <div className='col'>
                                        <div className='qn-title'><CwContentViewer content={question.content.title} /></div>
                                        {question.content.images.length ? question.content.images.map((image, imageIndex) =>
                                            <img className='image-container mb-4 mr-3' src={image.imageUrl} alt="" />
                                        )
                                            :
                                            ""}
                                    </div>
                                    <div className='col-1 d-flex align-items-center'>
                                        {
                                            (question.questionCategory === 'C1' ||
                                                question.content.competency && question.content.competency.id === 'YES' ||
                                                question.skill === 'Comprehension') ?
                                                <img className='info-icon-size mr-2' src={getImageSource(ImageConstants.YELLOW_BULB)} />
                                                :
                                                <img className='info-icon-size no-image-margin-right'></img>
                                        }
                                         {
                                            (!question.content.type || question.content.isMultiStep) ?
                                                <img className='info-icon-size mr-2' src={getImageSource(ImageConstants.MULTI_STEP_IMAGE)} />
                                                :
                                                <img className='info-icon-size no-image-margin-right'></img>
                                        }
                                    </div>
                                    <div className='col-1 d-flex align-items-center'>
                                        <img className='info-icon-size'
                                            data-tip={`${question.eloTitle}`}
                                            src={getImageSource(ImageConstants.INFO1)} />
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            ))
        )
    }

    showCompetency() {
        this.props.delegate && this.props.delegate.showCompetencyQuestionsOnly && this.props.delegate.showCompetencyQuestionsOnly(!this.state.showCompetencyOnly)
        this.setState({ showCompetencyOnly: !this.state.showCompetencyOnly })
    }



    onSelectAll = () => {

        if (this.state.selectAll) {
            for (let key in this.contentsHash) {
                this.contentsHash[key].selected = false
            }
            this.setState({ questionCount: 0, approximateTime: 0, selectAll: false }, () => {
                this.setSelectedQuestions(false, false)
            })
        } else {
            let selectedElo = []
            for (let key in this.contentsHash) {
                this.contentsHash[key].selected = true
                selectedElo.push(this.contentsHash[key].eloId)
            }
            this.props.delegate && this.props.delegate.getEloDetails && this.props.delegate.getEloDetails(selectedElo)
            this.setState({ selectAll: true }, () => {
                this.setSelectedQuestions(false, true, selectedElo)
            })
        }
    }


    render() {
        return (
            <div className='question-detail-new'>

                {/* <div className="abs-image">
                    <img className='cursor-pointer header-image' src={getImageSource(ImageConstants.HEADER1)} />
                </div> */}

                {/* <div className="pt-4 my-auto text-right"><img className='close-icon cursor-pointer' src={getImageSource(ImageConstants.CROSS)} onClick={this.onClickBack.bind(this)} /></div> */}




                {/* {
                    this.state.isCompetecyQuestionsPresent ?
                        <div className='d-flex justify-content-end cursor-pointer' onClick={() => this.showCompetency()} >
                            {
                                this.state.showCompetencyOnly ?
                                    <div>
                                        <img className="green-tick-icon-for-competency" src={getImageSource(ImageConstants.WHITE_CHECK_BOX)} />
                                    </div>
                                    :
                                    <div>
                                        <div className="empty-check-box"></div>
                                    </div>
                            }
                            <div className='d-flex align-items-center ml-2'>
                                <img className='yellow-bulb-icon mr-2' src={getImageSource(ImageConstants.YELLOW_BULB)} />
                                <span className='competency-text'>Show Competency Questions only</span>
                            </div>
                        </div>

                        :
                        <div className='d-flex justify-content-end cursor-pointer' onClick={() => this.showCompetency()} >

                            <div className='d-flex align-items-center ml-2'>
                                <img className='yellow-bulb-icon mr-2' src={getImageSource(ImageConstants.YELLOW_BULB)} />
                                <span className='competency-text'>No Competency Questions</span>
                            </div>
                        </div>

                } */}
                <div className='qs-border mt-4 mb-2'></div>
                {
                    <div className='select-all-absolute'>
                        {
                            this.state.selectAll ?
                                <div className='d-flex align-items-center ' >
                                    <img className="green-tick-icon-for-competency cursor-pointer" onClick={() => this.onSelectAll()} src={getImageSource(ImageConstants.WHITE_CHECK_BOX)} />
                                    <span className='pl-1 pt-1 cursor-pointer select-all-text' onClick={() => this.onSelectAll()}>All Questions</span>
                                </div>
                                :
                                <div className='d-flex align-items-center ' onClick={() => this.onSelectAll()}>
                                    <div className="empty-check-box cursor-pointer" onClick={() => this.onSelectAll()}></div>
                                    <div className='ml-1 pt-1 cursor-pointer select-all-text' onClick={() => this.onSelectAll()}>All Questions</div>
                                </div>
                        }
                    </div>
                }
                <div>
                    {this.renderList()}
                </div>
                {/* {
                    !this.props.questionSelection ?
                        <></>
                        :
                        <div className="modal-footer">
                            <button className="apply-btn" onClick={() => this.setSelectedQuestions(true)} >Apply Selected</button>
                            <button className="cancel-btn" onClick={this.onClickBack.bind(this)} >Cancel</button>
                        </div>
                } */}
                <ReactTooltip className="border arrow" arrowColor="#C4C4C4" ref={el => this.tooltip = el}
                    multiline={true} place='bottom' type='light' effect='solid'
                    event="mouseover mouseenter"
                    eventOff="mouseleave mouseout scroll mousewheel blur"
                />
            </div >
        );
    }
}

export default QuestionList;